import { IAppState } from '../../redux';
import { getDynamicPricingParameters } from '../../utils/dynamicPricing';
import { selectConfigValue } from '../config';

export function selectDynamicPricingParameters(state: IAppState): object {
  const dynamicPricingAttributes = selectConfigValue('dynamicPricingAttributes', state);

  const { offer } = state;

  return getDynamicPricingParameters({ offer, dynamicPricingAttributes });
}
